<div class="flex-fill d-flex flex-column dx-card">
    <div class="d-flex flex-column flex-fill responsive-paddings">
        <dx-data-grid
            #dataGrid
            class="grid-fill h-100"
            [dataSource]="photos"
            [showBorders]="true"
            [columnAutoWidth]="false"
            keyExpr="id"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowDblClick)="rowDoubleClick($event)"
        >
            <dxi-data-grid-column dataField="id" caption="Photo #" width="90"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="rentalId" caption="Rental #" width="90" cellTemplate="linkTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="rental.customer.displayName" caption="Customer" width="100" cellTemplate="linkTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="rental.siteAddressHTML" caption="Site Address" width="200" cellTemplate="linkTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="name" caption="File Name" width="300" cellTemplate="fileTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="notes" width="500"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="created" dataType="date" width="90"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="createdBy" width="125"></dxi-data-grid-column>
            <dxi-data-grid-column></dxi-data-grid-column>

            <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
            <dxo-data-grid-search-panel class="d-none d-sm-block" [visible]="true"></dxo-data-grid-search-panel>
            <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
            <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="pictures-overview-grid"></dxo-data-grid-state-storing>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="[]" [innerHtml]="cell.text" (click)="open(cell.data, cell.column.dataField)"></a>
            </div>
            <div *dxTemplate="let cell of 'fileTemplate'">
                <a [routerLink]="[]" (click)="openFile(cell.data)">{{ cell.value || '' }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    class="btn btn-primary"
                    (click)="edit(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Edit
                </button>
                <button
                    class="btn btn-danger ms-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                >
                    Delete
                </button>
            </div>
        </dx-data-grid>
    </div>
</div>
